module.exports = __webpack_public_path__ + "static/media/PATS_3-1018w.dca86dd9.png";